<template>
    <div class="container-fluid">
        <div class="row p-3">
            <div class="designRowOrga w-100">
                <div class="h3Organization">
                    <img src="../../../assets/images/title-icon.png" alt="">
                    <h3>Score</h3>
                </div>
                <div class="right-header-container">
                    <div class="twoInputs">
                        <div class="btnInsideInput w-100">
                            <button @click="searchBackEndHandler" ref="buttonSearch" class="search-btn">
                                <img src="../../../assets/images/SearchIcon.png" alt="">
                            </button>
                            <input type="text" id="free_search" class="form-control" v-model="search"
                                   placeholder="Search" autocomplete="off"
                                   @input="searchScore" maxlength="50">
                        </div>
                    </div>
                    <div class="btn-container">
                        <button @click="openPopup" class="open-btn">
                            Filters
                        </button>
                    </div>
                    <div v-if="isPopupVisible" class="modal-overlay">
                        <div class="modal-content">
                            <div class="fullInputs mb-4">
                                <div class="oneInput w-100">
                                    <select id="filter_dates" class="form-select" v-model="sort" @change="getCompetitionsScore">
                                        <option value="false" selected disabled >Sort by Date</option>
                                        <option value="asc">Oldest</option>
                                        <option value="desc">Latest</option>
                                    </select>
                                </div>
                            </div>
                            
                            <div class="tab p-0">
                                <router-link class="text-decoration-none tablinks h2 m-0"  to="/results" >Individual</router-link>
                                <router-link class="text-decoration-none tablinks h2 m-0 active" to="/results/team">Team</router-link>
                            </div>
                            <button @click="closePopup" class="close-btn">
                                x                          
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tabcontent tabcontent-border-style" v-if="scores.length > 0">
                <div class="table-container" >
                    <TableComponent :tbody="scores" @sort="SortOrganization" :thead="thead" :keys="keys" name="score" model="scoreTeams"
                                    updateUrl="/edit-scores" @update="updateScore"/>
                    <div class="paginationLink">
                        <pagination :data="laravelData" @pagination-change-page="getCompetitionsScore" :limit="3">
                            <template #prev-nav>
                                <span>Previous</span>
                            </template>
                            <template #next-nav>
                                <span>Next</span>
                            </template>
                        </pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TableComponent from "../../components/TableComponent";
    import LaravelVuePagination from 'laravel-vue-pagination';
    import score from "../../../api-services/score";

    export default {
        name:'userscore-pageTeam',
        data(){
            return {
                thead:['Competition Name' , 'Number Of Participants'],
                keys:['name' , 'number_of_participants'],
                permissions: [],
                scores: [],
                filteredArray: [],
                originalScores: [],
                laravelData: {},
                error: null,
                search: '',
                isPopupVisible: false,
                sort: false,
                state: false,
                isSearch:false,
            }
        },
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        async mounted(){
            await this.$store.dispatch('activeTap', 'results');
            this.getCompetitionsScore();
        },
        methods:{

            openPopup() {
                this.isPopupVisible = true;
            },
            closePopup() {
                this.isPopupVisible = false;
            },

            getCompetitionsScore: async function (page=1) {
                try {
                    const response = await score.indexTeam(this.search, this.sort === false ? this.sort = 'desc' : this.sort, page);
                    this.scores = response.data.data;
                    this.laravelData = response.data;
                    this.originalScores = response.data.data;

                } catch (e) {
                    console.log(e);
                    this.error = e;
                }

            },
            updateScore(e) {
                let filteredData = this.scores.filter(function (data) {
                    return data.id != e;
                });
                this.scores = filteredData;
            },
            searchScore(e) {
                // let serachedValue = e.target.value.toLowerCase();
                // let searchedData = null;
                //
                // searchedData = this.originalScores.filter((data) => data.name.toLowerCase().indexOf(serachedValue) >= 0 || (data.domain != null ? data.domain.toLowerCase().indexOf(serachedValue) >= 0 : false));
                // this.scores = searchedData;
                //
                // if (serachedValue !== '') {
                //     this.isSearch = true;
                // } else {
                //     this.isSearch = false;
                // }
            },
            async searchBackEndHandler(searchFlag = false) {
                await this.getCompetitionsScore();
            },
            SortOrganization() {
                let status = !this.state;
                this.originalScores.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.state = status;
            }
        }
    }
</script>

<style scoped>
    .no-data-header{
        font-size: 18px;
    }
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #DDD !important;
        opacity: 0.5 !important; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #DDD !important;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: #DDD !important;
    }
    .create-btn-text{
        font-size: 17px;
    }
    .tabcontent{
        height:73vh;
        padding-top: 0 !important;
        overflow-y: auto;
    }
    .h3Organization{
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
    }
    .h3Organization img{
        margin-bottom:0;
        padding-right: 10px;
    }
    .h3Organization h3{
        text-transform: uppercase;
        font-weight: 600;
        margin-bottom: 0;
        font-size: calc(1.1rem+0.6vw);
    }
    .right-header-container{
        display: flex;
        flex-direction: row;
        justify-content:end;
        width:45%;
        height: 35px;
        gap:10px;
    }
    .right-header-container .btn-container{
        font-size: 16px;
        width: 25%;
        font-weight: normal;
    }
    .twoInputs{
        width:45%;
    }
    .search-btn{
        width: 10%;
        border-radius: 6px 0 0 6px;
        background-color:#707070;
        align-items: center;
        padding-bottom: 3px;
    }
    .btnInsideInput{
        border-radius: 6px;
        background-color: #707070;
    }
    .btnInsideInput input{
        border-radius: 6px;
        background-color: #707070;
        padding-left: 0;
        padding-top: 5px;
        padding-bottom: 0;
        
    }
    .form-control {
        color: white !important;
        display: flex;
        justify-content: left;
        width:90% !important;
        padding-left: 10px !important;
    }
    .designRowOrga{
        padding-left:40px !important;
        padding-right: 40px;
        height: 50px;
        align-items: center;
        margin-bottom: 2%;
    }
    .paginationLink{
        font-size:11px;
        font-weight: bold;
        width:99%;
    }
    .fullInputs{
        width:100%;
        height:40px;
    }
    .oneInput{
        height: 100%;
    }
    #filter_dates{
        width:100% !important;
        border: none;
        padding:0;
        padding-left: 10px;
        height: 100% !important;
    }
    #free_search::placeholder{
        opacity: 1 !important;
        color: white !important;
        /* font-size: 19px; */
    }

    /* popup style */
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5); 
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000; 
    }


    .modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        background-color: var(--main-bg1-color); 
        padding: 60px 30px;
        border-radius: 8px;
        width: 340px;
        height: 360px;
        text-align: center;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    }


    .close-btn {
        background-color: #e74c3c;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        border-radius: 50px;
        width: 25px;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        height: 25px;
        position: absolute;
        top: 10px;
        right: 10px;
    }


    /* responsive style */
    @media(max-width:1280px){
        .h3Organization{
            width: 40% !important;
        }
        .h3Organization img{
            width: 5vh !important;
        }
        .right-header-container{
            width:60%;
            /* margin-top: 10px; */
        }
        .twoInputs{
            margin-bottom:0 !important;
        }
        .table-container :deep(thead :first-child){
        width:50% !important;
        }
        
        .tabcontent{
            padding-top: 0 !important;
            overflow-y: scroll;
        }
    }
    @media(max-height:767px){
        .tabcontent{
            height: 69vh;
        }
    }
</style>